export default "__VITE_ASSET__yjds0GU3__"